const Utils = {
    capitalizeFirstLetter: (string: string): string => string.charAt(0).toUpperCase() + string.slice(1),
    chunk: (arr: string[], size: number) =>
        Array.from({length: Math.ceil(arr.length / size)}, (v, i) =>
            arr.slice(i * size, i * size + size)
        )
}

export default Utils;
